import styled from 'styled-components';
import constants from '../../../../../core/constants';

export const CardCourseElement = styled.div.attrs((pr: any) => ({
  top: pr.top,
  height: pr.height,
  isOverlaping: pr.isOverlaping,
  cardType: pr.cardType,
  overlapingWithOtherEvents: pr.overlapingWithOtherEvents,
  isClicked: pr.isClicked,
  left: pr.left,
  width: pr.width,
  zIndex: pr.zIndex,
  cssclass: pr.cssclass,
  position: pr.position,
  isReprog: pr.isReprog,
  showIcon: pr.showIcon
}))`
    height: calc(${(p) => p.height}px - 2px);
    width: calc(${(p) => p.width}% + ${(p) => (p.left === 4 ? -10 : -4)}px);
    top: ${(p) => p.top}px;
    position: absolute;
    border-radius: 4px;
    left: ${(p) => Math.abs(p.left)}%;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  
    /* &.card-100-w {
      width: calc(100% - 4px);
    }
  
    &.card-100-w.active {
      padding-left: 8px;
    }
  
    &.card-50-w {
      width: calc(50% - 2px);
      left: 50%;
    }
  
    &.card-50-w.active {
      padding-left: 8px;
    }
  
    &.card-50-w:nth-child(2n + 1) {
      left: 0%;
      width: calc(50% - 4px);
    }
  
    &.card-50-w:nth-child(2n) {
      left: 50%;
    }
  
    &.card-50-w:first-child {
      left: 0%;
      width: calc(50% - 4px);
    }
  
    &.card-33-w.active {
      padding-left: 8px;
    }
  
    &.card-33-w {
      width: calc(33.333333% - 2px);
    }
  
    &.card-33-w {
      left: 33.333333%;
    }
  
    &.card-33-w:nth-child(n + 4) {
      left: 0%;
    }
  
    &.card-33-w:nth-child(3n + 3) {
      left: 66.666666%;
    } */
    /* &.card-33-w:nth-child(3n + 0) {
      left: 0%;
    }
  
    &.card-33-w:nth-child(3n + 1) {
      left: 33.333333%;
    }
  
    &.card-33-w:nth-child(3n + 2) {
      left: 66.666666%;
      width: calc(33.333333% - 4px);
    }
  
    &.card-33-w:nth-child(3n + 3) {
      left: 33.333333%;
    } */
  
    /* &.card-25-w {
      width: calc(25% - 2px);
    } */
  
    /* &.card-25-w:nth-child(4n + 1) {
      left: 75%;
    }
  
    &.card-25-w:nth-child(4n + 2) {
      left: 50%;
    }
  
    &.card-25-w:nth-child(4n + 3) {
      left: 25%;
    }
  
    &.card-25-w:nth-child(4n + 4) {
      left: 0%;
      width: calc(25% - 4px);
    } */
  
    /* &.active > div {
     padding-left: 10px; 
    } */
  
    .type-remote {
      background: #f1fbfa;
      border-left: 4px solid #66cac0;
    }
  
    .hours-1 {
      min-height: 40px;
    }
  
    .course-item.hours-2 {
      min-height: 80px;
    }
  
    .course-item.hours-3 {
      min-height: 120px;
    }
  
    .course-item.hours-4 {
      min-height: 160px;
    }
  
    .course-item {
      min-height: 40px;
      position: absolute;
      left: 0px;
      top: 0px;
      display: flex;
      width: 100%;
      border-bottom: 1px solid rgb(235, 241, 245);
      z-index: 9;
    }
  
    > div {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 100%;
      height: max-content;
    }
  
    .cardContent {
      outline: 0;
      // padding-top: 4px;
      // padding-bottom: 4px;
      // margin-left: ${(p) => (p.isReprog ? 4 : 0)}px;
      padding-right: ${(p) => (p.width <= 50 ? 4 : 8)}px;
      // padding-left: ${(p) => (p.width <= 50 ? 0 : 8)}px;
      padding-left: ${(p) => (p.isReprog ? 0 : 8)}px;
      padding-top: ${(p) => (p.isReprog ? 0 : 4)}px;
      cursor: pointer;
      border-radius: 4px;
      outline: ${(p) =>
        ['A', 'R', 'E'].includes(p.cardType) ? '1px solid #0060AB' : '0px'};
      background-color: var(--button-course-${(p) => p.cardType}-main);
      display: flex;
      position: relative;
    }
  
    .cardContent.clsReprog:before {
      content: '';
      height: 100%;
      width: 4px;
       
        background-image: linear-gradient(
          30deg,
          var(--button-course-${(p) => p.cardType}-stripes1) 25%,
          var(--button-course-${(p) => p.cardType}-stripes2) 25%,
          var(--button-course-${(p) => p.cardType}-stripes2) 50%,
          var(--button-course-${(p) => p.cardType}-stripes1) 50%,
          var(--button-course-${(p) => p.cardType}-stripes1) 75%,
          var(--button-course-${(p) => p.cardType}-stripes2) 75%,
          var(--button-course-${(p) => p.cardType}-stripes2) 100%
        );
        background-size: 16px 9.24px;
      }
    }
  
    .cardContent:hover {
      background-color: var(--button-course-${(p) => p.cardType}-hover);
    }
    .cardContent:focus {
      background: var(--button-course-${(p) => p.cardType}-focus);
    }
    &.active {
     
  
      background-image: linear-gradient(
        30deg,
        var(--button-course-${(p) => p.cardType}-stripes1) 25%,
        var(--button-course-${(p) => p.cardType}-stripes2) 25%,
        var(--button-course-${(p) => p.cardType}-stripes2) 50%,
        var(--button-course-${(p) => p.cardType}-stripes1) 50%,
        var(--button-course-${(p) => p.cardType}-stripes1) 75%,
        var(--button-course-${(p) => p.cardType}-stripes2) 75%,
        var(--button-course-${(p) => p.cardType}-stripes2) 100%
      );
      background-size: 16px 9.24px;
    }
  
    > div.cardContent > div > div > img {
      cursor: pointer;
    }
  
    > div.cardContent > div,
    > div.cardContent > div > div {
      cursor: pointer;
    }
  
    > div > div:first-child {
      display: flex;
      flex-direction: column;
      /* margin-top: 4px; */
    }
  
    > div > div {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  
    > div > div {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  
    .left {
      position: fixed;
      z-index: 9;
      top: 0px;
      right: 0px;
      bottom: 0px;
      height: 100%;
      > div: last-child {
        padding-bottom: 50px !important;
        padding-top: 20px !important;
      } 
    }
    .right {
      position: fixed;
      z-index: 9;
      top: 0px;
      right: 0px;
      bottom: 0px;
      height: 100%;
      > div: last-child {
        padding-bottom: 50px !important;
        padding-top: 20px !important;
      } 
    }
  
    .top {
      top: 40px;
    }
  
    .titleFontSize {
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      display: -webkit-box;
    }
  
    .ellipsis__css {
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 900;
      white-space: nowrap;
    }
  
    .hourFontSize {
      // color: #fff;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .tagFontSize {
      font-size: 12px;
      line-height: 16px;
      overflow: hidden;
      max-width: ${(p) => (p.showIcon ? '70%' : '85%')};
    }
  
    .label {
      cursor: pointer;
    }
  
    .elipsis label {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  
    .elipsis-1-lines label {
      -webkit-line-clamp: 1;
    }
  
    .elipsis-2-lines label {
      -webkit-line-clamp: 2;
    }
  
    .elipsis-3-lines label {
      -webkit-line-clamp: 3;
    }
  
    .elipsis-4-lines label {
      -webkit-line-clamp: 4;
    }
  
    .elipsis-5-lines label {
      -webkit-line-clamp: 5;
    }
  
    .elipsis-6-lines label {
      -webkit-line-clamp: 6;
    }
  
    .elipsis-7-lines label {
      -webkit-line-clamp: 7;
    }
  
    .elipsis-8-lines label {
      -webkit-line-clamp: 8;
    }
  
    .elipsis-9-lines label {
      -webkit-line-clamp: 9;
    }
  
    .elipsis-10-lines label {
      -webkit-line-clamp: 10;
    }
  
    > div.cardContent > div > div .titleFontSize {
      cursor: pointer;
    }
    > div.cardContent > div > div .hourFontSize {
      cursor: pointer;
    }
    > div.cardContent > div > div .tagFontSize {
      cursor: pointer;
    }
  
    @media (min-width:992px) {
      .right {
        position: fixed;
        z-index: 9;
        top: 0px;
        right: 0px;
        bottom: 0px;
        height: 100%;
      }
      .left {
        position: fixed;
        z-index: 9;
        top: 0px;
        right: 0px;
        bottom: 0px;
        height: 100%;
      }
      .titleFontSize {
        font-size: 14px;
        line-height: 20px;
      }
      .hourFontSize {
        font-size: 14px;
        line-height: 20px;
      }
      .tagFontSize {
        font-size: 12px;
        line-height: 16px;
      }
    }
  `;

export const TopDataInfo = styled.div.attrs((pr: any) => ({
  height: pr.height
}))`
  overflow: hidden;
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  margin-top: 0px;
  label {
    max-width: 100%;
    line-height: 14px;
    line-break: anywhere;
    word-break: break-all;
    /* cursor: pointer; */
    width: 100%;
  }

  > div {
    text-align: center;
  }

  span {
    font-weight: 700;
  }

  &.lastLine {
    margin-top: ${(p) => (p.height <= 60 ? '0' : '2')}px;
    margin-bottom: ${(p) => (p.height <= 60 ? '0' : '2')}px;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    .tag {
      font-size: 14px;
    }
  }
`;

export const TopDataInfo2 = styled.div.attrs((pr: any) => ({
  height: pr.height
}))`
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  gap: 14px;
  label {
    max-width: 100%;
    line-height: 14px;
    line-break: anywhere;
    word-break: break-all;
    /* cursor: pointer; */
  }

  > div {
    text-align: center;
  }

  span {
    font-weight: 700;
  }

  &.lastLine {
    margin-top: ${(p) => (p.height <= 60 ? '0' : '2')}px;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    .tag {
      font-size: 14px;
    }
  }
`;
